<template>
  <div>
    <div v-if="!showInput" data-test="digit-placeholder" class="authCodeInputBox border-border" :class="{'border-success': success}"><span>{{ value }}</span></div>
    <input
        data-test="digit-input"
        @paste="$event.preventDefault()"
        ref="input"
        v-if="showInput"
        :value="value"
        @keydown="handleKeypress"
        @input="$emit('input', $event.target.value)"
        pattern="[0-9]{1}"
        type="number"
        maxlength="1"
        min="0"
        max="9"
        class="authCodeInputBox border-border"
        :class="{'border-primary': showInput, 'border-success': success}"
    />
  </div>
</template>

<script>
export default {
  name: 'TWDigit',
  props: {
    showInput: Boolean,
    value: String,
    success: Boolean,
  },
  mounted() {
    if (this.showInput) {
      this.$refs.input.focus();
    }
  },
  watch: {
     showInput(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      }
    },
  },
  methods: {
    handleKeypress(e) {
      if (e.key === 'e') {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
